import React, { useContext, useMemo } from "react";
import { Flex } from "reflexbox";
import { Body } from "../../UI/Text";
import { useTheme } from "styled-components";
import { useLocation } from "react-router-dom";
import formatter from "../../../modules/formatter";
import ConfiguratorContext from "../../../context/configurator/ConfiguratorContext";

const DetailRow = ({ Detail, i }) => {
	const theme = useTheme();
	const location = useLocation();
	const { quote } = useContext(ConfiguratorContext);
	const isPlane = useMemo(() => quote?.isPlane, [quote]);
	const { 1: priceMode } = location.pathname.split("/");
	const isDealer = useMemo(
		() => priceMode === "DealerQuote" || !isPlane,
		[priceMode, isPlane]
	);

	const { Value, Caption: _Caption } = Detail || {};
	let discount = 1;
	const [priceCode, caption, ...rest] = _Caption.split(":");
	let ii = 0;
	for (let item of rest) {
		if (item.includes("Discount")) {
			const discString = +rest[ii + 1].replace("%", "");
			discount = discString / 100;
		}
		ii += 1;
	}

	if (priceCode === "<br/>") return <br />;

	if (priceCode === "<hr/>") {
		return (
			<Flex
				m="1rem auto"
				maxWidth="600px"
				key={_Caption + Value + i}
				width={1}
				style={{
					borderBottom: `2px solid ${theme.borderColor}`,
				}}
			/>
		);
	}
	if (priceCode?.startsWith("<b>")) {
		let caption = _Caption.replace("</b>", "").replace("<b>", "");
		return (
			<Flex
				m="0 auto"
				maxWidth="600px"
				key={caption + Value + i}
				width={1}
				alignSelf="right"
			>
				<Body flex={7} bold>
					{caption}
				</Body>
				<Body right>{Value}</Body>
			</Flex>
		);
	}

	const Caption = (
		<Body>
			{caption}:{" "}
			<span style={{ color: theme.secondary }}>
				{rest?.[0] === " " || rest?.[0] === "  " || !rest?.[0]
					? ""
					: discount !== 1
					? rest[0]?.split?.("Discount")?.[0]
					: rest}
			</span>
		</Body>
	);

	let numval;
	
	if (numval)
		numval= +Value.replace("$", "").replace(",", "");

	if (
		(priceCode === "DEALER" && isDealer) ||
		(priceCode === "MSRP" && !isDealer)
	)
		return (
			<Flex
				m="0 auto"
				maxWidth="600px"
				key={Caption + Value + i}
				width={1}
				alignSelf="right"
			>
				<Body flex={7} bold>
					{Caption}
				</Body>
				<Flex justifyContent="flex-end">
					{priceCode === "DEALER" && discount !== 1 && (
						<Body
							mr={0}
							w="auto !important"
							linethrough={priceCode === "DEALER" && discount !== 1}
							right
						>
							${formatter.currency((numval / (1 + discount)).toFixed(2))}
						</Body>
					)}
					<Body
						ml="1rem"
						w="auto !important"
						color={
							priceCode === "DEALER" && discount !== 1
								? theme.secondary
								: theme.textDark
						}
						right
					>
						{Value}
					</Body>
				</Flex>
			</Flex>
		);
	if (!["DEALER", "MSRP"].includes(priceCode))
		return (
			<Flex
				m="0 auto"
				maxWidth="600px"
				key={Caption + Value + i}
				width={1}
				alignSelf="right"
			>
				{" "}
				<Body flex={7} bold>
					{_Caption}
				</Body>
				<Body
					mr={0}
					w="auto !important"
					linethrough={priceCode === "DEALER" && discount !== 1}
					right
				>
					{Value}{" "}
				</Body>
			</Flex>
		);

	return null;
};

export default DetailRow;
